'use es6';

import { Record } from 'immutable';
const DEFAULTS = {
  id: 0,
  name: '',
  path: ''
};
class HubDbRow extends Record(DEFAULTS) {
  static fromJS({
    id,
    name,
    path
  }) {
    return new HubDbRow({
      id,
      name,
      path
    });
  }
}
export default HubDbRow;